import App from "../../services/App/App.js";
import ModelBody from "./PlosModel_Body.js";
import PlosChartCatalog from "./PlosChartCatalog.js";

// formula: AccountingBased
export default {
  getChart(transactionDetails) {
    let labelList = [], summaryObj = {};
    let result = ModelBody.createChart();

    this.getChart_populateInvoice(labelList, summaryObj, transactionDetails);
    this.getChart_populateInvoice_hppTotal(labelList, summaryObj, transactionDetails);
    this.getChart_populateHppAdj(labelList, summaryObj, transactionDetails);
    this.getChart_populateStockOpname(labelList, summaryObj, transactionDetails);
    this.getChart_populateRtnInvoice(labelList, summaryObj, transactionDetails);
    this.getChart_populateExpense(labelList, summaryObj, transactionDetails);
    this.getChart_populateStockReduction(labelList, summaryObj, transactionDetails);
    this.getChart_populateStockTrf(labelList, summaryObj, transactionDetails);

    let tempData, valueTotal = 0;
    labelList.sort();

    for (const row of labelList) {
      valueTotal += summaryObj[row];

      tempData = { Date: row };
      result.LabelList.push(
        App.Value.getValue("Date", tempData, PlosChartCatalog)
      );
      result.ValueList.push(
        App.Data.getFixedDecimal(summaryObj[row])
      );
    }

    result.ValueAvg = labelList.length === 0
      ? 0
      : App.Data.getFixedDecimal(valueTotal / labelList.length);
    result.ValueAvg = App.In.getDecimal(result.ValueAvg);

    return result;
  },
  getChart_populateInvoice(labelList, summaryObj, transactionDetails) {
    for (const row of transactionDetails.InvoiceList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] + row.Total;
      }
      else {
        summaryObj[row.Date] = row.Total;
        labelList.push(row.Date);
      }
    }
  },
  getChart_populateInvoice_hppTotal(labelList, summaryObj, transactionDetails) {
    for (const row of transactionDetails.InvoiceHppList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] - row.Total;
      }
      else {
        summaryObj[row.Date] = row.Total;
        labelList.push(row.Date);
      }
    }
  },
  getChart_populateHppAdj(labelList, summaryObj, transactionDetails) {
    for (const row of transactionDetails.HppAdjList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] + row.Total;
      }
      else {
        summaryObj[row.Date] = row.Total;
        labelList.push(row.Date);
      }
    }
  },
  getChart_populateStockOpname(labelList, summaryObj, transactionDetails) {
    for (const row of transactionDetails.StockOpnameList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] + row.Total;
      }
      else {
        summaryObj[row.Date] = row.Total;
        labelList.push(row.Date);
      }
    }
  },
  getChart_populateRtnInvoice(labelList, summaryObj, transactionDetails) {
    for (const row of transactionDetails.RtnInvoiceList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] - row.Total;
      }
      else {
        summaryObj[row.Date] = row.Total;
        labelList.push(row.Date);
      }
    }
  },
  getChart_populateExpense(labelList, summaryObj, transactionDetails) {
    for (const row of transactionDetails.ExpenseList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] - row.Total;
      }
      else {
        summaryObj[row.Date] = -1 * row.Total;
        labelList.push(row.Date);
      }
    }
  },
  getChart_populateStockReduction(labelList, summaryObj, transactionDetails) {
    for (const row of transactionDetails.StockReductionList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] - row.Total;
      }
      else {
        summaryObj[row.Date] = -1 * row.Total;
        labelList.push(row.Date);
      }
    }
  },
  getChart_populateStockTrf(labelList, summaryObj, transactionDetails) {
    if (!Object.prototype.hasOwnProperty.call(transactionDetails, "StockTrf")) {
      return;
    }

    for (const row of transactionDetails.StockTrf.AddList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] + row.Total;
      }
      else {
        summaryObj[row.Date] = row.Total;
        labelList.push(row.Date);
      }
    }

    for (const row of transactionDetails.StockTrf.SubList) {
      if (labelList.includes(row.Date)) {
        summaryObj[row.Date] = summaryObj[row.Date] - row.Total;
      }
      else {
        summaryObj[row.Date] = -1 * row.Total;
        labelList.push(row.Date);
      }
    }
  }
}